import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import RelationshipMap from "@/components/feature/RelationshipMap";
import { events } from "@/mocks/gossip";

export default function DecodeShowcase() {
  const decodable = events.filter((e) => e.relations.length >= 3);
  const [activeId, setActiveId] = useState(decodable[0]?.id ?? "");
  const active = decodable.find((e) => e.id === activeId) ?? decodable[0];

  if (!active) return null;

  return (
    <section className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.25em] text-accent-400 uppercase">
              <span className="w-6 h-px bg-accent-400"></span>
              关系图解码
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-[32px] leading-tight text-background-50">
              谁和谁是一条线，谁和谁是对立面
            </h2>
            <p className="mt-3 font-label text-sm md:text-[15px] leading-relaxed text-background-300">
              每条连线都对应正文中的一个时间节点。我们不凭猜测连线，只呈现有公开信息支撑的关系结构。
            </p>
          </div>
          <Link
            to={`/event/${active.id}`}
            className="group inline-flex items-center gap-2 shrink-0 rounded-md border border-background-700 px-5 py-2.5 font-label text-sm text-background-100 hover:border-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看该事件全部关系
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
          </Link>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {decodable.map((e) => (
            <button
              key={e.id}
              type="button"
              onClick={() => setActiveId(e.id)}
              className={`rounded-md px-4 py-2 font-label text-sm transition-colors cursor-pointer ${
                e.id === active.id
                  ? "bg-accent-500 text-accent-950"
                  : "bg-background-900 text-background-300 hover:bg-background-800 hover:text-background-50"
              }`}
            >
              {e.title.length > 14 ? `${e.title.slice(0, 14)}…` : e.title}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 rounded-lg border border-background-800 bg-background-900/60 p-5 md:p-8">
            <RelationshipMap nodes={active.relations} links={active.links} />
          </div>

          <div className="lg:col-span-4 flex flex-col gap-3">
            <div className="rounded-lg border border-background-800 bg-background-900/60 p-5">
              <p className="font-label text-xs tracking-widest text-accent-400">连线含义</p>
              <ul className="mt-3 space-y-3 font-label text-sm text-background-300">
                <li className="flex items-start gap-2.5">
                  <span className="mt-1.5 w-2 h-2 rounded-full bg-accent-400 shrink-0"></span>
                  关联：合作、同剧组、互相声援等正向关系
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="mt-1.5 w-2 h-2 rounded-full bg-secondary-300 shrink-0"></span>
                  对立：公开交锋、解约、爆料等冲突关系
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="mt-1.5 w-2 h-2 rounded-full bg-background-500 shrink-0"></span>
                  中性：保持沉默、观望或仅有关联但无明确立场
                </li>
              </ul>
            </div>
            <div className="rounded-lg border border-background-800 bg-background-900/60 p-5">
              <p className="font-label text-xs tracking-widest text-accent-400">关系节点</p>
              <p className="mt-2 font-heading font-bold text-3xl text-background-50">
                {active.relations.length}
                <span className="ml-1 font-label text-sm text-background-400">个</span>
              </p>
              <p className="mt-1 font-label text-xs text-background-400">
                连线 {active.links.length} 条 · 全部可溯源
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}